<script lang="ts" setup>
import departments from "~~/shared/meta/departments.json";

const layout = await useLayout();
const { loggedIn, user } = useUserSession();

// TODO move to composable ? need this more than once?
const departmentName = computed(() => {
  const match = departments.find(d => d.id === user.value?.departmentId);

  return match ? match.internalName : `Department #${user.value?.departmentId}`;
});
</script>

<template>
  <div v-if="layout && loggedIn" class="text-sm">
    <span class="font-medium">{{ layout.departmentLabel }}</span> <span class="font-bold">{{ departmentName }}</span>
  </div>
</template>

<style scoped>

</style>
